$("body").on("click", "#menu--trigger", function(){   
    let ul = $(".panel-right.panel-in").find("ul");
    if(!ul.hasClass("inited")){
        let width = 1;
        ul.find("li").each(function(k){
            width += $(this).outerWidth() + parseInt($(this).css("margin-right"));
        });
        ul.attr("style", "min-width:" + width + "px").addClass("d-flex inited");
    }
});